// src/app/providers.jsx
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useThemeMode } from "../shared/hooks/useThemeMode";

export function Providers({ children }) {
    const { theme } = useThemeMode(); // por ahora modo "light" fijo

    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </BrowserRouter>
    );
}
